import { defineStore } from "pinia";

export const useUserState = defineStore("user-state", {
    state: () => ({
        users: []
    }),
});
